/* ===================================================================
   Producto JDP — lógica con delegación de eventos.
   Se carga globalmente (no dentro de la sección) para que funcione
   también con el contenido clonado dentro del modal "Elegir",
   donde los <script> de sección nunca se ejecutan.
   =================================================================== */
(function () {
  var SECTION = '.jdp-product-section';

  function getVariants(root) {
    var el = root.querySelector('[data-jdp-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function formatMoney(root, cents) {
    var cur = root.getAttribute('data-currency') || 'MXN';
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function showMedia(root, mediaId) {
    if (!mediaId) return;
    root.querySelectorAll('[data-media-target]').forEach(function (btn) {
      btn.classList.toggle('is-active', String(btn.getAttribute('data-media-target')) === String(mediaId));
    });
    root.querySelectorAll('[data-media-id]').forEach(function (item) {
      var active = String(item.getAttribute('data-media-id')) === String(mediaId);
      item.classList.toggle('is-active', active);
      if (!active) {
        item.querySelectorAll('video').forEach(function (v) {
          try { v.pause(); } catch (e) {}
        });
      }
    });
  }

  function selectedOptions(root) {
    return Array.prototype.map.call(
      root.querySelectorAll('[data-option-position]'),
      function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      }
    );
  }

  function findVariant(root) {
    var variants = getVariants(root);
    var selected = selectedOptions(root);
    if (!selected.length) return variants[0];
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return String(opt) === String(selected[i]);
      });
    });
  }

  function updateWhatsApp(root, variant) {
    var wa = root.querySelector('[data-whatsapp]');
    if (!wa || !variant) return;
    var phone = (wa.getAttribute('data-phone') || '').replace(/\D/g, '');
    var title = root.getAttribute('data-product-title') || '';
    var input = root.querySelector('[data-jdp-source]');
    var wrapper = root.querySelector('#jdp-personalizacion-wrapper');
    var extra = '';
    if (input && wrapper && !wrapper.hasAttribute('hidden') && input.value.trim()) {
      extra = ' - Personalización: ' + input.value.trim();
    }
    var msg =
      'Hola, me interesa ' + title + ' - ' + variant.title + ' - ' +
      formatMoney(root, variant.price) + extra + '. ' + window.location.href;
    wa.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
  }

  function updateVariantUI(root, variant) {
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-text]');
    var priceEl = root.querySelector('[data-jdp-price]');
    var compareEl = root.querySelector('[data-jdp-compare]');
    var variantInput = root.querySelector('[data-variant-id]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Combinación no disponible';
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(root, variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(root, variant.compare_at_price);
        compareEl.classList.remove('is-hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('is-hidden');
      }
    }

    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) addText.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';

    if (variant.featured_media && variant.featured_media.id) showMedia(root, variant.featured_media.id);

    updateWhatsApp(root, variant);

    // Solo actualizamos la URL si NO estamos dentro del modal de "Elegir".
    if (!root.closest('#quick-add-modal-content')) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }

  /* ---------- CLICKS (delegados) ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var root = target.closest(SECTION);
    if (!root) return;

    var thumb = target.closest('[data-media-target]');
    if (thumb) {
      showMedia(root, thumb.getAttribute('data-media-target'));
      return;
    }

    var zoomBtn = target.closest('[data-zoom-src]');
    if (zoomBtn) {
      var dlg = root.querySelector('[data-zoom-dialog]');
      var img = root.querySelector('[data-zoom-image]');
      if (dlg && img) {
        img.src = zoomBtn.getAttribute('data-zoom-src');
        if (dlg.showModal) dlg.showModal();
        else dlg.setAttribute('open', '');
      }
      return;
    }

    if (target.closest('[data-zoom-close]')) {
      var d = root.querySelector('[data-zoom-dialog]');
      if (d && d.close) d.close();
      return;
    }

    var qtyInput = root.querySelector('[data-qty-input]');
    if (target.closest('[data-qty-minus]') && qtyInput) {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      return;
    }
    if (target.closest('[data-qty-plus]') && qtyInput) {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      return;
    }

    // Acordeones: sincronizar el signo + / −
    var summary = target.closest('.jdp-accordions summary');
    if (summary) {
      setTimeout(function () {
        var det = summary.parentElement;
        var b = summary.querySelector('b');
        if (det && b) b.textContent = det.open ? '−' : '+';
      }, 0);
    }
  });

  /* ---------- CAMBIO DE VARIANTE (delegado) ---------- */
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var root = target.closest(SECTION);
    if (!root) return;
    if (!target.matches('.jdp-option-btn input[type="radio"]')) return;

    var group = target.closest('[data-option-position]');
    if (group) {
      group.querySelectorAll('.jdp-option-btn').forEach(function (label) {
        var radio = label.querySelector('input[type="radio"]');
        if (!radio) return;
        label.classList.toggle('is-selected', radio.checked);
        radio.setAttribute('data-current-checked', radio.checked ? 'true' : 'false');
      });
    }
    updateVariantUI(root, findVariant(root));
  });

  /* ---------- TEXTO DE PERSONALIZACIÓN → WhatsApp ---------- */
  document.addEventListener('input', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.hasAttribute || !target.hasAttribute('data-jdp-source')) return;
    var root = target.closest(SECTION);
    if (!root) return;
    updateWhatsApp(root, findVariant(root));
  });

  /* ---------- AGREGAR AL CARRITO (delegado) ---------- */
  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.jdp-product-form')) return;

    var root = form.closest(SECTION);
    if (!root) return;

    e.preventDefault();

    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-text]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var variantInput = root.querySelector('[data-variant-id]');
    var variants = getVariants(root);

    var variant =
      findVariant(root) ||
      variants.find(function (v) {
        return String(v.id) === String(variantInput && variantInput.value);
      });

    if (!variant || !variant.available) return;

    // Si la validación global de personalización marcó error, no continuar.
    var errorEl = root.querySelector('[id^="jdp-error-"]');
    if (errorEl && !errorEl.hasAttribute('hidden')) return;

    var oldText = addText ? addText.textContent : '';
    if (addBtn) addBtn.disabled = true;
    if (addText) addText.textContent = 'Agregando…';

    var quantity = Math.max(1, Number(qtyInput && qtyInput.value) || 1);

    // Pedimos a Shopify que re-renderice las secciones del carrito.
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    var payload = { items: [{ id: Number(variant.id), quantity: quantity, properties: {} }] };
    if (sectionIds.length) payload.sections = sectionIds.join(',');

    var addUrl =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      var result = await response.json();

      if (result.status) {
        throw new Error(result.description || result.message || 'Error al agregar');
      }

      var cart = null;
      try {
        cart = await (await fetch('/cart.js')).json();
      } catch (err) {}

      if (addText) addText.textContent = oldText;
      if (addBtn) addBtn.disabled = false;

      // Evento nativo del tema: actualiza contador, cart drawer y cart items.
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: root.id || 'jdp-product',
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: root.getAttribute('data-product-id'),
              sections: result.sections,
            },
          },
        })
      );

      // Si estamos en la página de producto (no en el modal), abrimos el carrito.
      if (!root.closest('#quick-add-modal-content')) {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }
    } catch (error) {
      console.error(error);
      alert(error.message || 'No se pudo agregar el producto. Revisa la selección e inténtalo nuevamente.');
      if (addBtn) addBtn.disabled = false;
      if (addText) addText.textContent = oldText;
    }
  });

  /* ---------- INICIALIZACIÓN ---------- */
  function init(root) {
    if (root.getAttribute('data-jdp-init') === '1') return;
    root.setAttribute('data-jdp-init', '1');
    updateWhatsApp(root, findVariant(root));
    root.querySelectorAll('.jdp-accordions details').forEach(function (det) {
      var b = det.querySelector('summary b');
      if (b) b.textContent = det.open ? '−' : '+';
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El modal "Elegir" inyecta contenido clonado: lo inicializamos también.
  // Observer acotado al contenedor del modal (no a todo el body).
  function watchQuickAdd() {
    var modal = document.getElementById('quick-add-modal-content');
    if (!modal) return;
    new MutationObserver(function () {
      initAll();
    }).observe(modal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchQuickAdd);
  } else {
    watchQuickAdd();
  }
})();
